import"./RcTree.css";import{cn}from"../../utils/bem";export const cnTree=cn("RcTree");export const cnRcTree=(a,b)=>{const{size:c="s"}=a||{};return cnTree({size:c||"s"},b).split(" ").reverse().join(" ")};
//# sourceMappingURL=RcTree.js.map